module.exports = __webpack_public_path__ + "images/homepage-hero-bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-hero-bg.jpg
// module id = 850
// module chunks = 0